var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"profile-picture"},[_c('PictureInput',{on:{"change":_vm.changePhoto}}),_c('img',{staticClass:"profile-picture__avatar",attrs:{"src":_vm.userPhoto}}),_c('span',{staticClass:"profile-picture__description"},[_vm._v(" Alterar foto ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }